import { EdgeLabelVariant } from '@/components/diagrams/components/EdgeLabel';

import { CardConfig } from './Cards/types';

interface GetComputedEdgeLabelPropsParams {
  cards: CardConfig[];
  externalLabel?: string;
  index: number;
  isOpen: boolean;
  value?: string;
  variant?: EdgeLabelVariant;
}

export function getComputedEdgeLabelProps({
  cards,
  externalLabel,
  index,
  isOpen,
  value,
  variant,
}: GetComputedEdgeLabelPropsParams) {
  const hasAtLeastOneCard = cards.length > 0;
  const hasMultipleCards = cards.length > 1;

  let computedLabel = hasMultipleCards
    ? `Events (${cards.length})`
    : (externalLabel ?? '');
  let computedValue = hasMultipleCards ? undefined : value;
  let computedVariant = hasAtLeastOneCard ? cards[0]!.variant : variant;

  if (cards.length === 1) {
    computedLabel = cards[0]!.label ?? '';
    computedValue = cards[0]!.badgeValue ?? value;
  }

  if (hasMultipleCards && cards.some((c) => c.variant === 'secondary')) {
    computedVariant = 'secondary';
  }

  if (hasMultipleCards && isOpen) {
    computedLabel = cards[index]!.label ?? '';
    computedValue = cards[index]!.value;
    computedVariant = cards[index]!.variant;
  }

  return {
    computedLabel,
    computedValue,
    computedVariant,
  };
}
